/**
 * @package   ScandiPWA\GtmGraphQl
 * @author    Abdelrahman Hady <abdelrahman.hady@scandiweb.com>
 * @copyright Copyright (c) 2023 Scandiweb, Inc (https://scandiweb.com)
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 */

import Event, { EVENT_GTM_REMOVE_FROM_CART_GA4 } from '../../../util/Event';
import ProductHelper from '../GA4_utils';
import BaseEventEvent from './BaseEvent.event';

export const SPAM_PROTECTION_DELAY = 200;
/**
 * Remove product from cart event
 *
 * @namespace Gtm/Component/GoogleTagManager/GA4_events/RemoveFromCart/Event
 */
export class RemoveFromCartEvent extends BaseEventEvent {
    /**
     * Bind
     */
    bindEvent() {
        Event.observer(EVENT_GTM_REMOVE_FROM_CART_GA4, ({
            item,
            quantity
        }) => {
            this.handle(item, quantity);
        });
    }

    /**
     * Handle
     */
    handler(...args) {
        const [item] = args;
        const { quantity: quantityParam } = item;

        const quantity = quantityParam === undefined
            || quantityParam === null
            // eslint-disable-next-line no-restricted-globals
            || isNaN(quantityParam) ? 0 : quantityParam;

        if (this.spamProtection(SPAM_PROTECTION_DELAY)) {
            return;
        }

        const itemListData = this.getItemListData(item.product);
        const productData = {
            ...ProductHelper.getItemData(item),
            quantity,
            ...itemListData
        };
        const { id, price } = productData;
        const removedGroupedProduct = ProductHelper.updateGroupedProduct(id, -price * quantity);

        const removedProducts = removedGroupedProduct
            ? [
                { ...productData, quantity, ...itemListData },
                removedGroupedProduct.data
            ]
            : [{ ...productData, ...itemListData }];

        this.pushEventData({
            currency: this.getCurrencyCode(),
            value: price * quantity,
            items: Array.from(removedProducts)
        });
    }
}

export default RemoveFromCartEvent;
